
import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { UserProfilePicture } from '../users';
import { ParticipantElement } from './types';

@Component({
  components: {
    UserProfilePicture,
  },
})
export default class ParticipantCard extends Vue {
  @Prop({ required: true }) readonly participant!: ParticipantElement;
  @Prop({ required: true }) readonly linkName!: string;
  @Prop({ type: Boolean, default: false }) readonly isParticipant!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isOrganizer!: boolean;
}
